// Plain data (no React) so src/lib/structuredData.js can build the FAQPage
// schema from the same questions the page renders without pulling this
// lazily loaded page into the main bundle.
//
// `link` is optional: the list turns that phrase inside the answer into a
// link, while the schema keeps the plain sentence.
export const FAQS = [
  {
    question: "Can I dictate emails in Gmail with Zero Typing?",
    answer:
      "Yes. Click into a Gmail message, start Zero Typing, and speak. Your words appear as clean, punctuated text in the compose box. Zero Typing works across everyday apps including Gmail, Google Docs, Slack, and AI chat tools, so you do not need a separate tool for each one.",
  },
  {
    question:
      "What makes an AI email dictation tool better than standard dictation?",
    answer:
      "Standard dictation often returns a raw transcript that you still need to correct. Zero Typing adds punctuation, fixes grammar, and can adjust tone as part of the process, so there is less to fix before you send. For a closer look, read our comparison of voice typing vs built in dictation.",
    link: {
      label: "voice typing vs built in dictation",
      href: "/blog/voice-typing-vs-built-in-dictation",
    },
  },
  {
    question: "Can Zero Typing change the tone of my email?",
    answer:
      "Yes. The Writing Tone prompt reshapes how your message sounds, Fix Grammar cleans up the language, and Transcript Only keeps your exact words. You choose the option that fits each email.",
  },
  {
    question: "Will it spell client and company names correctly?",
    answer:
      "Yes, if you add them to your Personal Dictionary. Save names, industry terms, and brand words once, and Zero Typing spells them the way you intended each time you speak.",
  },
  {
    question: "Does Zero Typing work in languages other than English?",
    answer:
      "Zero Typing uses AI powered automatic language detection, so it identifies the language you are speaking and writes your words in that language.",
  },
  {
    question: "Is Zero Typing free?",
    answer:
      "There is a free plan that includes 15 minutes of audio transcription per week, a Personal Dictionary, and basic prompt selection. Pro is $8 per month, or 20% less with annual billing, and adds unlimited words and custom prompts. Details are on the pricing page.",
    link: { label: "pricing page", href: "/pricing" },
  },
  {
    question: "Which devices does Zero Typing support?",
    answer:
      "Zero Typing is available for Mac and Windows through the download page, for Android on Google Play, and as a web app.",
    link: { label: "download page", href: "/download" },
  },
  {
    question: "Is Zero Typing only for email?",
    answer:
      "No. It works across everyday apps, including Google Docs, Slack and Notion, and AI chat tools. Need setup help? Visit the Help Center.",
    link: { label: "Help Center", href: "/help" },
  },
];
